<template>
    <transition name="fade">
        <div class="preview-image" v-show="show" @click="onClose">
            <swiper
                v-if="show"
                :paginationVisible="true"
                direction="horizontal"
                :lazyLoad="true"
                :initPage="current + 1"
                :swiperData="urls"
                class="swiper"
            >
                <div
                    v-for="(url, index) in urls"
                    :key="index"
                    class="swiper-item nut-swiper-slide"
                >
                    <img :data-src="url" style="max-width:100%; max-height:100%" class="nut-img-lazyload"/>
                </div>
            </swiper>
        </div>
    </transition>
</template>

<script>
import Swiper from '../swiper.vue';

export default {
    data() {
        return {
            show: false,
            urls: [],
            current: 0,
        };
    },
    methods: {
        onClose() {
            this.show = false;
        },
    },
    components: {
        Swiper,
    },
};
</script>

<style lang="scss" scoped>
.preview-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    z-index: 200;
    .swiper {
        width: 100vw;
        height: 100vh;
    }
    .swiper-item {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
